<template>
  <v-snackbar
    v-model="openLogoutDialog"
    bottom
    left
    :color="sessionEnded ? 'warning' : 'info'"
    timeout="-1"
    :multi-line="sessionEnded"
  >
    <v-progress-linear
      :active="sessionEnded"
      absolute
      top
      color="orange lighten-3"
      v-model="countdown"
      reverse
    ></v-progress-linear>
    <span v-if="!sessionEnded"
      >Votre session se terminera dans {{ endSessionTimerFormatted }}</span
    >
    <span v-else
      >Votre session s'est terminée.<br />Vous allez être redirigé.e vers la
      page de connexion</span
    >
    <template v-slot:action="{ attrs }">
      <v-btn
        dark
        text
        v-bind="attrs"
        @click="goToLoginPage"
        v-if="!sessionEnded"
      >
        Se reconnecter
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
import Vue from "vue";
import { computed, watch, ref, onBeforeMount } from "@vue/composition-api";
import router from "@/router";

export default Vue.extend({
  props: {
    open: Boolean,
    endSessionTimer: Number,
  },
  setup(props, { emit }) {
    onBeforeMount(() => {
      countdown.value = 0;
    });
    let countdown = ref(0);
    let progressTimerId = -1;
    let openLogoutDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });
    const sessionEnded = computed(function () {
      return props.endSessionTimer <= 0;
    });
    const endSessionTimerFormatted = computed(function () {
      let timerFormatted = "";
      const storeTimer = props.endSessionTimer;
      const minutes = storeTimer % 60;
      const hours = Math.floor(storeTimer / 60);
      const minutesString = minutes < 10 ? `0${minutes}` : minutes.toString();
      const hoursString = hours < 10 ? `0${hours}` : hours.toString();
      timerFormatted =
        hours > 0 ? `${hoursString}:${minutesString}` : `${minutesString} min`;

      return timerFormatted;
    });
    const goToLoginPage = function () {
      openLogoutDialog.value = false;
      clearInterval(parseInt(localStorage.getItem("sessionTimerId")));
      localStorage.setItem("sessionTimerId", -1);
      localStorage.setItem("lastVisitedUrl", router.currentRoute.path);
      localStorage.removeItem("sessionInfos");
      localStorage.removeItem("token");
      if (progressTimerId > 0) {
        clearInterval(progressTimerId);
      }
      router.push({ name: "login" });
    };
    watch(sessionEnded, (newValue, oldValue) => {
      if (newValue && !oldValue) {
        progressTimerId = setInterval(function () {
          countdown.value += 2.5;
          if (countdown.value >= 100) {
            goToLoginPage();
          }
        }, 100);
      }
    });
    return {
      openLogoutDialog,
      endSessionTimerFormatted,
      goToLoginPage,
      countdown,
      sessionEnded,
    };
  },
});
</script>
